import { render } from "./InsuranceSaleTitle.vue?vue&type=template&id=ab3f567e"
import script from "./InsuranceSaleTitle.vue?vue&type=script&lang=js"
export * from "./InsuranceSaleTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__